import { useQuery } from '@tanstack/react-query';

import { options } from './query-options';

export const useGlobalIndicesQuery = () => useQuery(options.getIndices());

export const useGlobalCommoditiesQuery = () => useQuery(options.getCommodities());
